import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from '@/layout/App.vue';
import { router } from '@/scripts/router';
import { useSchoolIndexStore } from '@/stores/schoolIndex';
import { useYearStore } from '@/stores/year';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);

// Kick background fetches before any page mounts so caches are warm by first navigation.
void useSchoolIndexStore(pinia).EnsureLoaded();
void useYearStore(pinia).load();

await router.isReady();
app.mount('body');
